module.exports = __webpack_public_path__ + "assets/img/mecha-btn-a9edd8d0.png";